import React, { useEffect, useState } from "react";
import "./Sponsors.css";
import { useTranslation } from "react-i18next";
import { apiFetch } from "../../helpers/api";

const Sponsors = () => {
  const { t } = useTranslation();
  const [sponsors, setSponsors] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchSponsors = async () => {
    try {
      const data = await apiFetch("/api/sponsors"); 
      setSponsors(data);
    } catch (error) {
      console.error("Error fetching sponsors:", error);
      setSponsors([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSponsors();
  }, []);

  return (
    <section className="about-sponsors">
      <h3>{t("aboutUs.sponsors.title")}</h3>

      {loading ? (
        <p>{t("loading")}</p>
      ) : sponsors.length > 0 ? (
        <div className="sponsor-grid">
          {sponsors.map((sponsor) => (
            <div key={sponsor.id || sponsor.name} className="sponsor-card">
              <img
                src={sponsor.logo || "/images/sponsor-placeholder.png"}
                alt={sponsor.name || "Sponsor"}
                className="sponsor-logo"
              />
            </div>
          ))}
        </div>
      ) : (
        <div className="sponsor-placeholder-wrapper">
          <img
            src="/images/sponsor-placeholder.png"
            alt="Placeholder sponsor"
            className="sponsor-placeholder"
          />
        </div>
      )}
    </section>
  );
};

export default Sponsors;
